// @ts-ignore: Resolve path aliases
import React, { useState } from 'react';
// @ts-ignore
import { PageSection } from '@/components/ui/page-section';
// @ts-ignore
import { getSection } from '@/config/navigation';
import { ValueStreamPerformanceMap } from './ValueStreamPerformanceMap';
import { Tabs, TabsContent } from '../ui/tabs';
// @ts-ignore
import { staticValueStreamData } from './valueStreamData';

type AggregationLevel = 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly';

export function ValueStreamPerformancePage() {
  const section = getSection('valueStreamPerformance');
  const [activeTab, setActiveTab] = useState<string>('overview');
  const [isChartExpanded, setIsChartExpanded] = useState(true);
  const [aggregation, setAggregation] = useState<AggregationLevel>('daily');

  const toggleChartExpanded = () => {
    setIsChartExpanded(!isChartExpanded);
  };

  return (
    <PageSection section={section}>
      <div className="flex flex-col gap-4">
        <Tabs value={activeTab} onValueChange={(value: string) => setActiveTab(value)} className="w-full flex flex-col">
          <TabsContent value="overview" className="flex flex-col flex-grow min-h-0">
            <div className="flex items-center justify-end pb-2">
              <div className="flex gap-1">
                {(['daily', 'weekly', 'monthly', 'quarterly', 'yearly'] as AggregationLevel[]).map((level) => (
                  <button
                    key={level}
                    onClick={() => setAggregation(level)}
                    className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
                      aggregation === level
                        ? 'bg-primary text-primary-foreground'
                        : 'bg-muted hover:bg-muted/80'
                    }`}
                  >
                    {level.charAt(0).toUpperCase() + level.slice(1)}
                  </button>
                ))}
              </div>
            </div>
            <ValueStreamPerformanceMap
              initialView="overview"
              isChartExpanded={isChartExpanded}
              toggleChartExpanded={toggleChartExpanded}
              aggregation={aggregation}
            />
          </TabsContent>
        </Tabs>
      </div>
    </PageSection>
  );
}
